module.exports = __webpack_public_path__ + "static/media/spc_logo.51afd359.jpg";